/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import ToggleBtn from "../SidebarComponent/ToggleBtn/ToggleBtn";
import "./Nav.css";
import { Dropdown, MenuProps } from "antd";
import { useNavigate } from "react-router";
// import { logoutUser } from "../../services/auth/AuthAPI";

function AuthNav(props: any) {
  const location = window.location.pathname;
  const user = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("userData"))));

  const navigate = useNavigate();
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <div onClick={() => navigate("/")}>Logout</div>,
    },
  ];
  return (
    <div className="top-nav-bar w-100 d-flex  justify-content-between border-bottom">
      <ToggleBtn
        openSidebar={() => props.openSidebar()}
        closeSidebar={() => props.closeSidebar()}
      />
      <Dropdown
        menu={{ items }}
        trigger={["click"]}
        placement="bottom">
        <button
          className="user-container  "
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          <div className="d-flex align-items-center gap-1">
            <span className="material-symbols-outlined">person</span>
            <span>{user.idToken.payload.name}</span>
            <span className="material-symbols-outlined">arrow_drop_down</span>
          </div>
        </button>
      </Dropdown>
    </div>
  );
}

export default AuthNav;
